import syntube_config from "../config/syntube_config.json";

const fetchVideos = async () => {
    const apiKey = process.env.REACT_APP_YOUTUBE_API_KEY;  // Access API key from .env
    const url = `https://www.googleapis.com/youtube/v3/playlistItems?part=contentDetails,snippet&playlistId=${syntube_config.playlistId}&maxResults=${syntube_config.maxResults}&key=${apiKey}`;

    try {
        const response = await fetch(url);

        if (!response.ok) {
            // If the response is not OK, throw an error
            throw new Error(`HTTP error! Status: ${response.status} - ${response.statusText}`);
        }

        const data = await response.json();
        return data;

    } catch (error) {
        // Log the error message
        console.error('Error fetching videos:', error);

        // Throw the error so it can be handled by the caller
        throw error;
    }
};

export default fetchVideos;